import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const SuperAdminRoute = ({ children }) => {
  const auth = useSelector((state) => state.auth);
  const isAuthenticated = auth?.isAuthenticated;
  const userType = auth?.user?.type;

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (userType !== "superadmin") {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default SuperAdminRoute;
